import DesistedLayout from './desisted-layout';

const HurryUpPage = () => {

    return (
        <DesistedLayout />
    );
}

export default HurryUpPage;
